import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import Button from '../../buttons/Button';
import withMeta from '../../utils/withMeta';

const Seq = ({ selected, showMsg, db, meta }) => {
  const [state, setState] = useState({
    isOpen: false,
    isLoading: false
  });

  const handleOpen = () => {
    setState((prevState) => ({ ...prevState, isOpen: true }));
  };

  const handleClose = () => {
    setState((prevState) => ({ ...prevState, isOpen: false }));
  };

  const handleConfirm = async () => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    try {
      for (const x of selected) {
        await meta.setSeq(x.NSeq, db);
      }
      showMsg('Akcia inicializácie sekvencií prebehla úspešne');
    } catch (error) {
      showMsg(error.message, 'error');
    }

    setState((prevState) => ({ ...prevState, isOpen: false, isLoading: false }));
  };

  // const handleChange = (name, value) => {
  //   setState(prevState => ({ ...prevState, [name]: value }));
  // }

  return (
    <>
      <ConfirmDialog
        isOpen={state.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        text="Spustiť inicializáciu sekvencií ?"
        confirmText="Áno"
        cancelText="Nie"
      />
      <Button
        onClick={handleOpen}
        title="Inicializácia sekvencií"
        icon="sort-asc"
        disabled={selected && selected.length === 0}
      />
    </>
  );
}

Seq.propTypes = {
  selected: PropTypes.array.isRequired,
  showMsg: PropTypes.func.isRequired,
  db: PropTypes.string,
  meta: PropTypes.object
}

export default withMeta(Seq);